<template>
    <a href="/cart.php?act=step2" title="Shopping Cart" class="roundboxmenu cart"><i class="fa fa-cart-plus" style="font-size: 1.2em;"></i>&nbsp;Cart&nbsp;( {{this.countItems}} )</a>
</template>

<script>
import {bus} from '../../bus'
export default {
    data() {
        return {
            countItems: 0
        }
    },
    created() {
        this.updateCart()
        this.countItemsFunc()
    },
    methods: {
        updateCart() {
            bus.$on('cart-was-updated', () => {
                this.countItemsFunc()
            })
        },
        countItemsFunc() {
            let items = JSON.parse(localStorage.getItem('items')) || []
            this.countItems = 0
            items.forEach(item => {
                this.countItems += parseInt(item.quantity)
            })
        }
    },
    mounted() {

    }
}
</script>
